import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidBellSlashIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="m21.7 20.3-1.8-1.8L7.5 6.1 3.7 2.3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l4.1 4.1C6.1 8.5 6 9.3 6 10v3.2c-1.2.4-2 1.5-2 2.8v2c0 .6.4 1 1 1h3.1c.5 2.1 2.7 3.4 4.8 2.9 1.4-.4 2.5-1.5 2.9-2.9h1.7l2.7 2.7c.4.4 1 .4 1.4 0 .5-.4.5-1 .1-1.4ZM12 20c-.7 0-1.4-.4-1.7-1h3.5c-.4.6-1.1 1-1.8 1Zm6-6.8V10c0-2.9-2.1-5.4-5-5.9V3c0-.6-.4-1-1-1s-1 .4-1 1v1.1c-.7.1-1.4.4-2 .7l11 10.9c-.1-1.1-.9-2.1-2-2.5Z"/>
  </SvgIcon>
}

export default SolidBellSlashIcon
